import React, { useState, useEffect, useRef } from "react";
import Map from "../map";
import './ordersmap.css';
import { useFetch } from "../../api/FetchApiData";
import Select from "react-select";

export default function OrdersMap({close, order=null})
{
    const [orders,setOrders] = useState([]);
    const [selectOptions,setSelOptions] = useState([]);
    const [order_,setOrder] = useState(null);
    const [mapComment,setMapComment] = useState(null);
    const fetchData = useFetch();
    const ref_ids = useRef([])
    //const [routing,setRouting] = useState({display:false, from:[-11.472917,43.393561], to:[-11.463004,43.38916]});

    const onMapMoveEnd = (bounds)=>{
        try{
        fetchData.PostData({bounds:bounds},'sales/filter/1/').then((result)=>{
            if(result.result)
            {
                let arr = [];
                let ids = [];
                orders.map((ord)=>{
                    ids.push(ord.id);
                })
                result.sales.forEach(element => {
                    let address = {...element.address,orders:[]};
                    address.type = 'delivery_point';
                    if(!ids.includes(address.id))
                    {
                        address = {...address,orders:[element.order_number]}
                        arr.push(address);
                        ids.push(address.id);
                    }
                    else
                    {   
                        const ind = orders.findIndex((el)=>el.id===address.id);
                        if(ind>-1 && !!orders[ind].orders)
                            orders[ind].orders.push(element.order_number);
                    }

                });
                setOrders([...new Set([...orders, ...arr])])
            }
        })}
        catch(e){console.log(e);}
    }

    useEffect(()=>{
        let ids = [];
        let arr = [];
        orders.map((address)=>{
        if(!ids.includes(address.id))
        {
                arr.push({
                label:
                <div style={{fontSize:'small'}}>
                    <h4 style={{margin:'0px',fontSize:'small'}}>{address.label}</h4>
                    <label style={{color:'gray', fontStyle:'italic'}}>{address.display_name} {/*address.orders.map((order_)=>{return <span>{order_+', '}</span>})*/}</label><br/>
                </div>,
                value:address.label,
                tag:address
            });
            ids.push(address.id);
        }
    });
    setSelOptions([...arr]);
    },[orders]);

    useEffect(()=>{
        if(!!order)
        {
            const address = order.address;
            setOrder({
                label:
                <div>
                    <h4 style={{margin:'0px'}}>{address.label}</h4>
                    <label style={{color:'gray', fontStyle:'italic'}}>{address.display_name} {/*address.orders.map((order_)=>{return <span>{order_+', '}</span>})*/}</label><br/>
                </div>,
                value:address.label,
                tag:address})
            }
    },[order])

    useEffect(()=>{
        if(!!order_)
        {
            //setRouting({display:false, from:[-11.472917,43.393561], to:[order_.tag.coords.latitude,order_.tag.coords.longitude]});
        }
    },[order_])
    
    return(
        <div id="MapContent" style={{height:'90vh',width:'100%',marginTop:'45px'}}>
            <Map onMoveEnd={onMapMoveEnd} zoom={15} locations={orders} setComment={setMapComment} newLocation={null} />
            <div className='orders-map-controls'>
                <div className="orders-map-itin-button">
                    <div style={{width:'80%', fontSize:'small',marginRight:'5px'}}>
                        <Select options={selectOptions} />
                    </div>
                    <div className="close-order-map">
                        <a onClick={e=>{close()}}>
                            &times;
                        </a>
                    </div>
                </div>
                {!!mapComment && <label style={{backgroundColor:'white',display:'block',fontSize:'x-small',marginTop:'2px',padding:'5px 0px 5px 0px',borderRadius:'3px',border:'1px solid lightgray'}}>{mapComment}</label>}
            </div>
        </div>);
}